import { createQueryKeys } from '@lukemorales/query-key-factory';

export const marketing = createQueryKeys('marketing', {
  brandKit: null,
  history: null,
  historyDetail: (id: string) => [id],
  projects: (q: string) => [q],
  usage: null,
});
